/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSubcategoriesDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategories-dto';

export interface GetMenuSubcategoriesByMenuCategoryId$Params {
  menuCategoryId: string;
  isRemoved?: boolean;
}

export function getMenuSubcategoriesByMenuCategoryId(http: HttpClient, rootUrl: string, params: GetMenuSubcategoriesByMenuCategoryId$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuSubcategoriesByMenuCategoryId.PATH, 'get');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.query('isRemoved', params.isRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoriesDto>;
    })
  );
}

getMenuSubcategoriesByMenuCategoryId.PATH = '/api/menu-categories/{menuCategoryId}/menu-subcategories';
